module.exports = __webpack_public_path__ + "img/ic-descente_escalier.6bd6cb1d.svg";